import React from "react";
// import "../css/volunteerThankYou.scss"; // Optional: your own styles

const VolunteerThankYou = () => {
    return (
        <section
            style={{
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "60px 20px",
                background: "linear-gradient(120deg, #fdf2f2, #fffbea)",
            }}
        >
            <div style={{ textAlign: "center", maxWidth: "800px", margin: "auto" }}>
                <div
                    style={{
                        display: "inline-block",
                        border: "1px solid #facc15",
                        color: "#b91c1c",
                        backgroundColor: "#ffffff",
                        padding: "6px 20px",
                        fontWeight: "600",
                        borderRadius: "999px",
                        fontSize: "0.9rem",
                        marginBottom: "20px",
                    }}
                >
                    ✨ Request Submitted
                </div>

                <h1
                    style={{
                        fontSize: "3rem",
                        fontWeight: "bold",
                        background: "linear-gradient(90deg, #b91c1c, #f59e0b)",
                        WebkitBackgroundClip: "text",
                        WebkitTextFillColor: "transparent",
                        marginBottom: "10px",
                    }}
                >
                    THANK YOU!
                </h1>

                <div
                    style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        gap: "10px",
                        marginBottom: "30px",
                    }}
                >
                    <hr
                        style={{
                            width: "100px",
                            border: "none",
                            borderTop: "1px solid #e5e7eb",
                        }}
                    />
                    <span style={{ fontSize: "1.2rem", color: "#dc2626" }}>❤️</span>
                    <hr
                        style={{
                            width: "100px",
                            border: "none",
                            borderTop: "1px solid #e5e7eb",
                        }}
                    />
                </div>

                <h2
                    style={{
                        fontSize: "1.5rem",
                        fontWeight: "600",
                        color: "#1f2937",
                        marginBottom: "20px",
                    }}
                >
                    Your Sacred Seva Application Has Been Received.
                </h2>

                <p
                    style={{
                        fontSize: "1rem",
                        color: "#374151",
                        lineHeight: "1.6",
                    }}
                >
                    Thank you for registering for the Volunteers Seva â€“ your willingness to serve and share is truly appreciated. Our volunteers will reach out to you with the confirmation details.
                </p>
            </div>
        </section>

    );
};

export default VolunteerThankYou;